import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import DirectoryPage from "./pages/DirectoryPage";
import ContractorDetailPage from "./pages/ContractorDetailPage";
import RegisterPage from "./pages/RegisterPage";
import PayrollEmployeePage from "./pages/PayrollEmployeePage";
import StatusPage from "./pages/StatusPage";
import ReportsPage from "./pages/ReportsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminResetPasswordPage from "./pages/AdminResetPasswordPage";
import ContractorPortalPage from "./pages/ContractorPortalPage";
import WorkmanPortalPage from "./pages/WorkmanPortalPage";
import WorkmanVerifyPage from "./pages/WorkmanVerifyPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import AdminMastersPage from "./pages/AdminMastersPage";
import WorkmenApprovalsPage from "./pages/WorkmenApprovalsPage";
import ContractorApprovalsPage from "./pages/ContractorApprovalsPage";
import PayRosterApprovalsPage from "./pages/PayRosterApprovalsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import AppUpdateBanner from "./components/AppUpdateBanner";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              {/* Login IS the front page */}
              <Route path="/" element={<AdminLoginPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/reset-password" element={<AdminResetPasswordPage />} />
              <Route path="/portal" element={<ContractorPortalPage />} />
              <Route path="/workman" element={<WorkmanPortalPage />} />
              <Route path="/workman-verify/:id" element={<WorkmanVerifyPage />} />
              <Route path="/directory" element={<DirectoryPage />} />
              <Route path="/contractor/:id" element={<ContractorDetailPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/register/payroll" element={<PayrollEmployeePage />} />
              <Route path="/status" element={<StatusPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
              <Route path="/admin/masters" element={<AdminMastersPage />} />
              <Route path="/admin/workmen-approvals" element={<WorkmenApprovalsPage />} />
              <Route path="/admin/contractor-approvals" element={<ContractorApprovalsPage mode="contractor" />} />
              <Route path="/admin/payroll-approvals" element={<ContractorApprovalsPage mode="payroll" />} />
              <Route path="/admin/pay-roster-approvals" element={<PayRosterApprovalsPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster richColors position="top-right" />
          <PWAInstallPrompt />
          <AppUpdateBanner />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
